var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.addClass},[_c('b-form-select',{attrs:{"options":_vm.options},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }